shvenergy.customselects = (function ($) {

	function init() {

		var customSelects = $(".custom-select");

		customSelects.each(function (index) {

			var selectedItem = $(this).find(".select-selected");
			var options = $(this).find(".select-items > div");

			selectedItem.on("keypress", function (e) {
				e.stopPropagation();
				if (e.which === 13) {

					if ($(this).hasClass("select-arrow-active"))
						closeAllCustomSelects();
					else {
						$(this).next("div").toggleClass("select-hide");
						$(this).toggleClass("select-arrow-active");
					}

				}
			});

			selectedItem.on("click", function (e) {
				e.stopPropagation();
				closeAllCustomSelects();
				$(this).next("div").toggleClass("select-hide");
				$(this).toggleClass("select-arrow-active");

			});

			options.each(function () {


				$(this).on("click", function () {
					var uid = $(this).data("value");
					$(this).closest(".product-categories").find(".product-details-tab").hide();
					$(this).closest(".product-categories").find("#tab-" + uid).show();

					var selectedText = $(this).text();

					selectedItem.find("span").text(selectedText);
					shvenergy.tracking.trackEvent("product changed", "click", selectedText);

					//category, action, label
				});


				$(this).on("keypress", function (e) {
					e.stopPropagation();
					if (e.which === 13) {

						var uid = $(this).data("value");
						$(this).closest(".product-categories").find(".product-details-tab").hide();
						$(this).closest(".product-categories").find("#tab-" + uid).show();
						var selectedText = $(this).text();
						selectedItem.find("span").text(selectedText);
						shvenergy.tracking.trackEvent("product changed", "click", selectedText);
						closeAllCustomSelects();
						$(this).closest(".product-categories").find(".select-selected").focus();
					}
				});

			});

		});

		function closeAllCustomSelects() {

			$(".select-selected").removeClass("select-arrow-active");
			$(".select-items").addClass("select-hide");

		}

		/*if the user clicks anywhere outside the select box,
		then close all select boxes:*/
		document.addEventListener("click", closeAllCustomSelects);

	}

	init();

})(jQuery);